module.exports = __webpack_public_path__ + "static/flexi-fd84f2c9f1023a823325c8c2baaf5c4f.png";